export default {
  form: {
    cancel: 'Cancel',
    label: 'Update the address you entered?',
    recommended: 'Recommended',
    save: 'Save',
    whatYouEntered: 'What you entered',
  },
  modal: {
    header: 'We found a better address',
  },
};
